import {
  Typography,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
////////////////////////
const DISCOUNT = 0.2; //
////////////////////////
const row_cost = [
  {
    id: 1,
    role: "Contributor",
    cost: "10",
    plan: "Creator",
  },
  {
    id: 2,
    role: "Developer",
    cost: "30",
    plan: "Studio",
  },
  {
    id: 3,
    role: "Gamer",
    cost: "5",
    plan: "Community",
  },
];
const row_user = [
  {
    id: 1,
    role: "Contributor",
    user: "Sell to Developers",
  },
  {
    id: 2,
    role: "Developer",
    user: "Buy from Contributors, Sell to Gamers",
  },
  {
    id: 3,
    role: "Gamer",
    user: "Buy from Developers",
  },
];
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
export function Plans(props) {
  const { panel: __panel__ } = props;
  return (
    <Box className="pk__page">
      <Box className="pk__block">
        <Box className="pk__info">
          <Typography variant="caption" color="secondary.dark">
            Last updated July, 23 2026
          </Typography>
        </Box>
        <Typography
          variant="h4"
          color="#606060"
          paddingTop={5}
          paddingBottom={2}
        >
          <strong>Access Plans & User Roles</strong>
        </Typography>
        <Box className="pk__body">
          <Box className="stub stub--title">
            <span className="token">1.</span>
            <div>
              <span className="token header">Participant Roles</span>
              <Box className="stub stub--title" pt={1}>
                <TableContainer className="pk__table">
                  <Table aria-label="pricing">
                    <TableHead>
                      <TableRow>
                        <TableCell>Plan</TableCell>
                        <TableCell>Participant Role</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row_cost.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.plan}</TableCell>
                          <TableCell>{row.role}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </div>
          </Box>
          <Box className="stub stub--title">
            <span className="token">2.</span>
            <div>
              <span className="token header">Fees.</span>This section outlines
              the recurring fees, if any, for access to and use of the Platform
              based on the Participant Role. All amounts are in [USD] unless
              otherwise specified.
            </div>
          </Box>
          <Box className="stub">
            <TableContainer className="pk__table">
              <Table aria-label="pricing">
                <TableHead>
                  <TableRow>
                    <TableCell>Plan</TableCell>
                    <TableCell>Subscription Fee</TableCell>
                    <TableCell>Billing Frequency</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row_cost.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.plan}</TableCell>
                      <TableCell>
                        <div>
                          {formatter.format(row.cost * (1 - DISCOUNT))} / mo
                        </div>
                        <div
                          style={{
                            fontStyle: "italic",
                            fontFamily: "Lato-regular",
                            fontWeight: 400,
                          }}
                        >
                          (or {formatter.format(row.cost)} billed monthly)
                        </div>
                      </TableCell>
                      <TableCell>
                        Annually
                        <span style={{ fontStyle: "italic" }}>
                          (Save {DISCOUNT * 100}%)
                        </span>
                        , Monthly
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box className="stub stub--title">
            <span className="token">3.</span>
            <div>
              <span className="token header">Available Functionality.</span>
              The features and functions available to the Participant are
              determined by their selected role and are described in the
              Documentation. This Access Plan enables the specific
              functionalities listed below.
            </div>
          </Box>
          <Box className="stub">
            <TableContainer className="pk__table">
              <Table aria-label="pricing">
                <TableHead>
                  <TableRow>
                    <TableCell>Participant Role</TableCell>
                    <TableCell>Permission Set</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row_user.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.role}</TableCell>
                      <TableCell>{row.user}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box className="stub stub--title">
            <span className="token">4.</span>
            <div>
              <span className="token header">Premium Games.</span>This section
              applies to Developers publishing premium Games on the Polycaik
              Platform. These fees are separate from any Fees.
            </div>
          </Box>
          <Box className="stub" flexDirection="column" paddingBottom={0}>
            <Box className="stub">
              <span className="header">a.</span>
              <div>
                <span className="token header">Developer Revenue Share.</span>
                Developer shall be entitled to 80% of the gross revenue received
                by Polycaik from the sale of the Developer’s premium Games to
                Gamers. Polycaik shall be entitled to the remaining 20%.
              </div>
            </Box>
            <Box className="stub">
              <span className="header">b.</span>
              <div>
                <span className="token header">Billing and Payout.</span>
                Payout of the Developer Payout will be made in accordance with
                the payouts terms in the Platform Agreement.
              </div>
            </Box>
          </Box>
          <Box className="stub stub--title">
            <span className="token">5.</span>
            <span className="token header">Developer Fees to Contributor.</span>
          </Box>
          <Box className="stub" flexDirection="column" paddingBottom={0}>
            <Box className="stub">
              <span className="header">a.</span>
              <div>
                <span className="token header">Contributor Revenue Share.</span>
                Contributor shall be entitled to 85% of the gross revenue
                received by Polycaik from the sale of Game Content to
                Developers. Polycaik shall be entitled to the remaining 15%
              </div>
            </Box>
            <Box className="stub">
              <span className="header">b.</span>
              <div>
                <span className="token header">Payout of the Contributor.</span>
                Payout of the Contributor Payout will be made in accordance with
                the payouts terms in the Platform Agreement.
              </div>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
